export const ER_ALERT_BY_LINK_ID = "er-alert-by-link-id";
